/* eslint-disable max-len */
import React from 'react';

const Back: React.FC<object> = () => {
    return (
        <svg width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_6576_138977)">
                <path
                    d="M12 0C15.1826 1.69219e-06 18.235 1.26421 20.4854 3.51465C22.7358 5.76508 24 8.8174 24 12C24 15.1826 22.7358 18.235 20.4854 20.4854C18.235 22.7358 15.1826 24 12 24C8.81741 24 5.76508 22.7358 3.51465 20.4854C1.26421 18.235 0 15.1826 0 12C1.46489e-06 8.81739 1.26421 5.76508 3.51465 3.51465C5.76508 1.26421 8.8174 0 12 0ZM14.7061 6.29199C14.3155 5.90208 13.6823 5.90183 13.292 6.29199L8.29199 11.292C8.24378 11.3403 8.20133 11.3925 8.16504 11.4473C7.90568 11.8357 7.94746 12.366 8.29004 12.709C8.30484 12.7238 8.32143 12.7373 8.33691 12.751L13.293 17.707C13.6834 18.0974 14.3165 18.0971 14.707 17.707C15.0976 17.3165 15.0976 16.6835 14.707 16.293L10.4131 11.999L14.7061 7.70605C15.0964 7.3155 15.0965 6.68243 14.7061 6.29199Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_6576_138977">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Back;